'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @fileoverview 浏览器相关
 * @author kirkzheng
 */

var userAgent = (typeof navigator === 'undefined' ? 'undefined' : _typeof(navigator)) === 'object' && navigator.userAgent.toLowerCase();

/**
 * 获取浏览器版本
 * @return {Number} -1表示不是ie，其他就是6/7/8/9/10/11
 */
var getBrowserVersion = exports.getBrowserVersion = function getBrowserVersion() {
    var result = void 0;

    result = parseInt((/msie (\d+)/.exec(userAgent) || [])[1], 10);
    if (isNaN(result)) {
        result = parseInt((/trident\/.*; rv:(\d+)/.exec(userAgent) || [])[1], 10);
    }

    if (isNaN(result)) {
        result = -1;
    }

    return result;
};

/**
 * 是否IE
 */
var isIE = exports.isIE = getBrowserVersion() > 0;

exports.default = {
    getBrowserVersion: getBrowserVersion,
    isIE: isIE
};